import { useEffect, useRef, useState } from "react";

/** Overflow (kebab) menu pinned to the right edge of the top bar. */
const KebabMenu = () => {
  const [open, setOpen] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) {
      return;
    }
    const onPointerDown = (event: PointerEvent) => {
      if (!rootRef.current?.contains(event.target as Node)) {
        setOpen(false);
      }
    };
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        setOpen(false);
      }
    };
    document.addEventListener("pointerdown", onPointerDown);
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("pointerdown", onPointerDown);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [open]);

  return (
    <div className="kebab" ref={rootRef}>
      <button
        type="button"
        className="kebab__btn"
        aria-label="More options"
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((wasOpen) => !wasOpen)}
      >
        <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
          <circle cx="12" cy="5" r="2.2" fill="currentColor" />
          <circle cx="12" cy="12" r="2.2" fill="currentColor" />
          <circle cx="12" cy="19" r="2.2" fill="currentColor" />
        </svg>
      </button>
      {open && (
        <nav className="kebab__menu" aria-label="More options">
          {/* Plain anchor: /login is server-routed (redirects into the
              dashboard app), not a homepage SPA route. */}
          <a className="kebab__item mono" href="/login">
            Manager log in
          </a>
        </nav>
      )}
    </div>
  );
};

export default KebabMenu;
